import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { RadioButton, Heart, ClockCounterClockwise, GlobeHemisphereWest } from "@phosphor-icons/react";
import { usePlayer } from "../context/PlayerContext";
import { PlayerBar } from "./PlayerBar";

const navItems = [
  { to: "/", label: "Discover", icon: GlobeHemisphereWest, testid: "nav-discover" },
  { to: "/favorites", label: "Favorites", icon: Heart, testid: "nav-favorites" },
  { to: "/history", label: "History", icon: ClockCounterClockwise, testid: "nav-history" },
];

export const Layout = ({ children }) => {
  const { favorites } = usePlayer();
  const navigate = useNavigate();

  const handleLogoClick = (event) => {
    event.preventDefault();
    navigate("/", { state: { resetHomeAt: Date.now() } });
  };

  return (
    <div className="min-h-screen">
      {/* Top nav */}
      <header className="sticky top-0 z-40 border-b border-border bg-[rgba(9,9,11,0.8)] backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1600px] items-center justify-between px-4 py-4 md:px-8">
          <NavLink to="/" data-testid="logo" onClick={handleLogoClick} className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold text-black">
              <RadioButton weight="fill" size={20} />
            </span>
            <span className="font-heading text-xl font-semibold tracking-tight text-foreground">
              Radio<span className="text-gold">Hub</span>
            </span>
          </NavLink>

          <nav className="flex items-center gap-1 rounded-full border border-border bg-surface p-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-full px-3.5 py-2 text-sm font-medium transition-colors md:px-4 ${
                    isActive ? "bg-gold text-black" : "text-muted2 hover:text-foreground"
                  }`
                }
              >
                <item.icon size={18} weight="duotone" />
                <span className="hidden sm:inline">{item.label}</span>
                {item.to === "/favorites" && favorites.length > 0 && (
                  <span className="ml-0.5 rounded-full bg-black/20 px-1.5 text-xs">{favorites.length}</span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-[1600px] px-4 pb-40 pt-8 md:px-8">{children}</main>

      <PlayerBar />
    </div>
  );
};
